import React from "react";
import UltraModernAdminPage from "../components/UltraModernAdminPage";

export default function AdminPage() {
  return <UltraModernAdminPage />;
}
